import { computed } from "nanostores";

import { getEvent, listEvents, Options } from "../api";
import { ListEventsData } from "../api/types.gen";
import { createCursorPaginationStore } from "../stores/cursor-pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $eventPagination = createCursorPaginationStore();

const $cursorParam = computed(
  $eventPagination.$cursorParams,
  (cursor) => cursor ?? "",
);

export const $eventsList = createApiStore(listEvents, {
  mapToOptions: ([cursorParam]): Options<ListEventsData, false> => {
    return {
      query: {
        cursor: cursorParam || undefined,
      },
    };
  },
  params: [$cursorParam],
  storeKey: "eventList",
});

export const $eventContent = createApiStore(getEvent, {
  mapToOptions: ([eventId]) => ({
    path: { id: eventId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "id" in router.params ? (router.params.id as string) : null;
    }),
  ],
  storeKey: "eventContent",
});
